module.exports = __webpack_public_path__ + "public/images/monkey.595963b1b873dc1faa9c0aa726606e11.png";